import { Checkbox } from '@chakra-ui/react';

interface SaveDefaultCheckboxProps {
  isChecked: boolean;
  onChange: (details: { checked: boolean | 'indeterminate' }) => void;
}

export const SaveDefaultCheckbox: React.FC<SaveDefaultCheckboxProps> = ({
  isChecked,
  onChange,
}) => {
  return (
    <Checkbox.Root
      checked={isChecked} // Use the prop for checked state
      onCheckedChange={onChange} // Use the prop for change handler
      colorPalette="primary" // Use colorPalette
    >
      <Checkbox.HiddenInput />
      <Checkbox.Control />
      <Checkbox.Label>Save as default payment method</Checkbox.Label>
    </Checkbox.Root>
  );
};
